import React, { PropsWithChildren } from 'react';

import useFeatureGate from '@/hooks/useFeatureGate';
import { ComponentId } from '@/models/channelModels';

type GateProps = { allow: ComponentId; fallback?: React.ReactNode } | { componentId: ComponentId; fallback?: React.ReactNode };

export default function Gate(props: PropsWithChildren<GateProps>) {
  const { allowComponent } = useFeatureGate();
  const id: ComponentId = 'allow' in props ? props.allow : props.componentId;
  const fallback = 'fallback' in props ? props.fallback : null;

  if (!allowComponent(id)) return <>{fallback}</>;
  return <>{props.children}</>;
}
